/**
 * Canonical job copy for EMT-facing UI.
 * Employer jobs may use summary / responsibilities / highlights; older docs use description + requirements[].
 */

export function getCanonicalJobDescription(job: Record<string, unknown> | null | undefined): string {
  if (!job) return '';
  const desc = job.description;
  if (typeof desc === 'string' && desc.trim()) return desc.trim();

  const parts: string[] = [];
  const summary = job.summary;
  if (typeof summary === 'string' && summary.trim()) parts.push(summary.trim());
  const resp = job.responsibilities;
  if (typeof resp === 'string' && resp.trim()) parts.push(resp.trim());
  const highlights = job.highlights;
  if (Array.isArray(highlights) && highlights.length > 0) {
    parts.push(highlights.map((h) => String(h)).filter(Boolean).join('\n'));
  } else if (typeof highlights === 'string' && highlights.trim()) {
    parts.push(highlights.trim());
  }
  return parts.join('\n\n');
}

export function getCanonicalJobRequirementsLines(job: Record<string, unknown> | null | undefined): string[] {
  if (!job) return [];
  const lines: string[] = [];
  const req = job.requirements;
  if (Array.isArray(req) && req.length > 0) {
    lines.push(
      ...req
        .map((r) => (typeof r === 'string' ? r : String((r as { name?: string })?.name ?? r)))
        .filter(Boolean)
    );
  }
  const { requiredYears, requiredSkills } = (() => {
    const y = job.requiredYears;
    const requiredYears = typeof y === 'number' && y >= 0 ? y : 0;
    const requiredSkills = Array.isArray(job.requiredSkills) ? (job.requiredSkills as string[]) : [];
    return { requiredYears, requiredSkills };
  })();
  if (requiredYears > 0) lines.push(`${requiredYears}+ years EMS experience`);
  if (requiredSkills.length > 0) lines.push(`Required skills: ${requiredSkills.join(', ')}`);
  if (job.openToRelocation === true) lines.push('Open to candidates willing to relocate');
  if (lines.length > 0) return lines;
  const tags = job.tags;
  if (Array.isArray(tags) && tags.length > 0) {
    return tags.map((t) => String(t)).filter(Boolean);
  }
  return [];
}
